import { IsNotEmpty, IsUUID } from 'class-validator';

export class PublishPolicyVersionDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsNotEmpty()
  versionId: string;
}
